<template>
  <div class="view">
    <div class="cover">
      <div class="overlay">
        <h1>{{room.name}}</h1>
      </div>
      <img :src="getImage(room.pictures[0]._id)" />
    </div>
    <div class="content" >
      <div v-html="$t('room.description')"></div>
      <carousel :perPage="1" :paginationEnabled="false" :autoplay="true" :autoplayHoverPause="true" :loop="true" :speed="1000">
        <slide v-for="pic in room.pictures" :key="pic._id">
          <img :src="getImage(pic._id)" />
        </slide>
      </carousel>
      <div class="rooms">
        <h2>{{$t('room.others')}}</h2>
        <div class="links">
          <div class="link" @click="goToRoom(room)" v-for="room in otherRooms" :key="room._id">
          <div class="name">
            {{room.name}}
          </div>
          <img :src="getImage(room.main_image._id)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Carousel, Slide } from 'vue-carousel';
// @ is an alias to /src
export default {
  name: 'Room',
  components: {
    Carousel,
    Slide
  },
  computed: {
    ...mapState({
      rooms: state => state.rooms.list,
      room: state => state.rooms.current,
      images: state => state.images.list,
    }),
    otherRooms() {
      return this.rooms.filter(r => r._id !== this.room._id)
    }
  },
  methods: {
    goToRoom (room) {
      this.$store.commit('rooms/select_room', room)
      this.$router.push({name: 'room'})
    },
    scroll () {
      if (window.innerWidth > 850) {
        window.scrollTo(0, window.innerHeight - 50)
      }
    },
    getImage(id) {
      let path = ''
      this.images.map(i => {
        if (i._id === id) {
          path = i.source.path
        }
      })
      return path
    },
  },
  mounted () {
    if (!this.room) {
      this.$router.push({name: 'rooms'})
    }
  }
}

</script>

<style lang="scss" scoped>
.cover {
  position: relative;
  width: 100%;
  height: calc(100vh - 50px);
  overflow: hidden;
  @media (max-width: 850px) {
    height: auto;
    // min-height: 250px;
  }
  img {
    pointer-events: none;
    width: 100vw;
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    background: rgba(0,0,0,0.4);
    h1 {
      font-size: 50px
    }
    a {
      position: absolute;
      bottom: 80px;
      left: 0;
      right: 0;
      margin: auto;
      width: 100px;
      cursor: pointer;
      img {
        width: 50px;
        transform: rotate(90deg);
      }
    }
    .basic-info {
      position: absolute;
      bottom: 20px;
      left: 0;
      width: 100%;
      height: 60px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      div {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 0 20px;
        height: 100%;
        width: 150px;
        line-height: 60px;
        font-size: 20px;
        font-weight: bold;
        img {
          pointer-events: none;
          width: auto;
          margin-right: 10px;
          height: 40px;
        }
      }

    }
  }
}
.content {
  padding: 0 50px;
  @media (max-width: 500px) {
    padding: 10px;
  }
  .VueCarousel {
    margin: 50px auto;
    width: 100%;
    height: 480px;
    max-width: 640px;
    overflow: hidden;
    @media (max-width: 400px) {
      height: 300px;
    }

    @media (max-width: 320px) {
      height: 260px;
    }

    img {

      pointer-events: none;
      width: 100%;
    }
  }
  p {
    text-align: left;
    font-size: 22px;
  }

  .mentions {
    margin-top: 50px;
    p {
      font-size: 14px;
      color: black;
    }
  }
  .rooms {
    .links {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      .link {
        position: relative;
        margin: 10px 30px;
        width: 250px;
        height: 160px;
        overflow: hidden;
        @media (max-width: 400px) {
          width: 100%;
        }
        img {
          pointer-events: none;
          z-index: 1;
          object-fit: cover;
          width: 100%;
          transition: transform 0.4s ease;
        }
        .name {
          z-index: 2;
          position: absolute;
          width: 100%;
          height: 100%;
          color: white;
          display: flex;
          background-color: rgba(0,0,0,0.4);
          justify-content: center;
          align-items: center;
          font-size: 20px;
          top: 0;
          left: 0;
        }
        &:hover {
          cursor: pointer;
          img {
            transform: scale(1.1);
          }
        }
      }
    }
  }
}

</style>